import { StorageModule } from "./modules/storage";
import { getFile } from "./api/user";
import { resolve } from "dns";
export const getUuid = () => {
  let uuid = StorageModule.getUuid();
  if (!uuid) {
    uuid = `${+new Date()}_${Math.floor(Math.random() * 100)}`;
    StorageModule.setUuid(uuid);
  }
  return uuid;
};

export const getImage = async (id) => {
  try {
    let response = await getFile(id);
    let blob = new Blob([response.data || response], { type: "image/png" });
    const base64 = await blob2base64(blob);
    return base64;
  } catch (err) {
    return "";
  }
};

export const blob2base64 = (blob) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.onload = (e) => {
      resolve(e.target.result);
    };
    // readAsDataURL
    fileReader.readAsDataURL(blob);
    fileReader.onerror = () => {
      reject(new Error("blobToBase64 error"));
    };
  });
};
/**
 *
 * @param {深拷贝} obj
 * @returns
 */
export const deepCopy = (obj) => {
  var ret, k, b;
  if ((b = obj instanceof Array) || obj instanceof Object) {
    ret = b ? [] : {};
    for (k in obj) {
      if (obj[k] instanceof Array || obj[k] instanceof Object) {
        ret[k] = deepCopy(obj[k]);
      } else {
        ret[k] = obj[k];
      }
    }
  }

  return ret;
};

export const fetchSvg = async (url) => {
  try {
    const response = await fetch(getImgUrlById(url));
    const svgText = await response.text();
    resolve(svgText);
  } catch (error) {
    console.error("Failed to fetch SVG:", error);
  }
};

export const getImgUrlById = (id) => {
  let pre = "";
  // if (window.location.href.indexOf('localhost') > -1) {
  //   pre = process.env.REACT_APP_SCP+'/';
  // } else {
  //   pre = `./`;
  // }
  pre = process.env.REACT_APP_SCP + "/";
  return `${pre}api/rubik/file/${id}/raw?Authorization=${StorageModule.getUser().token}`;
};
//获取指定字符个数
export const getCharCount = (str, char) => {
  var regex = new RegExp(char, "g"); // 使用g表示整个字符串都要匹配
  var result = str.match(regex); //match方法可在字符串内检索指定的值，或找到一个或多个正则表达式的匹配。
  var count = !result ? 0 : result.length;
  return count;
};
//相同属性合并为一个数组 arr 原数组 str属性字段，sort排序字段
export const sortArr = (arr, str, sortStr) => {
  var _arr = [],
    _t = [],
    _tmp;

  arr = arr.sort(function (a, b) {
    var s = b[str],
      t = a[str];
    return s < t ? -1 : 1;
  });
  if (arr.length) {
    _tmp = arr[0][str];
  }
  for (var i in arr) {
    if (arr[i][str] === _tmp) {
      _t.push(arr[i]);
      // console.log(arr[i])
    } else {
      _tmp = arr[i][str];
      _arr.push(_t);
      _t = [arr[i]];
    }
  }
  _arr.push(_t);
  _arr.map((item) => {
    item = item.sort(function (a, b) {
      var s = Number(a[sortStr]),
        t = Number(b[sortStr]);
      return s < t ? -1 : 1;
    });
  });
  console.log("_arr", _arr);
  return _arr;
};
//根据属性排序
export const sortKey = (property) => {
  return function (a, b) {
    var value1 = a[property];
    var value2 = b[property];
    return value1 - value2;
  };
};
/**
 * 防抖函数
 * @param fun
 * @param wait
 * @returns
 */
export function debounce(fun, wait = 1000) {
  let timer;
  return function () {
    if (timer) {
      clearTimeout(timer);
    }
    let isNow = !timer;
    timer = setTimeout(() => {
      timer = null;
    }, wait);
    if (isNow) fun();
  };
}
/**
 * 节流函数
 * @param fun
 * @param wait
 * @returns
 */
export function throttle(fun, wait = 1000) {
  let timers;
  return function () {
    if (!timers) {
      timers = setTimeout(() => {
        fun();
        timers = null;
      }, wait);
    }
  };
}
//对象数组去重
export function duplicateRemoval(Arr, id) {
  let obj = {};
  const arrays = Arr.reduce((setArr, item) => {
    if (!obj[item[id]]) {
      obj[item[id]] = true && setArr.push(item);
    }
    // obj[item[id]] ? "" : (obj[item[id]] = true && setArr.push(item));
    return setArr;
  }, []);
  return arrays;
}
//获取url参数
export const getUrlParams = (url) => {
  // 通过 ? 分割获取后面的参数字符串
  let urlStr = url.split("?")[1];
  if (!urlStr) return null;
  // 创建空对象存储参数
  let obj = {};
  // 再通过 & 将每一个参数单独分割出来
  console.log(urlStr);
  let paramsArr = urlStr.split("&");
  for (let i = 0, len = paramsArr.length; i < len; i++) {
    // 再通过 = 将每一个参数分割为 key:value 的形式
    let arr = paramsArr[i].split("=");
    obj[arr[0]] = arr[1];
  }
  return obj;
};
